import React from 'react';
import PropTypes from 'prop-types';

/**
 * SectionEyebrow — small label above a section headline.
 *
 * Matches the existing `.section-landing__eyebrow` class in
 * `frontend/src/pages/HomePage/Home.css` so it visually composes with the
 * landing sections without re-declaring styles.
 *
 * Props:
 *   serif     - if true, swap to the editorial serif (--font-family-serif)
 *               in italic for the "chapter title" feel used by Manifesto /
 *               FinalCTA / new dark sections.
 *   as        - rendering element (default 'span').
 *   children  - eyebrow text content.
 *   className - extra classes appended after the base class.
 */
const SectionEyebrow = ({
  serif = false,
  as: Tag = 'span',
  className = '',
  children,
  style,
  ...rest
}) => {
  const serifStyle = serif
    ? {
        fontFamily: 'var(--font-family-serif)',
        fontStyle: 'italic',
        textTransform: 'none',
        letterSpacing: '0',
        fontWeight: 400,
      }
    : null;

  const mergedStyle = serifStyle ? { ...serifStyle, ...(style || {}) } : style;
  const composedClass = `section-landing__eyebrow ${className}`.trim();

  return (
    <Tag className={composedClass} style={mergedStyle} {...rest}>
      {children}
    </Tag>
  );
};

SectionEyebrow.propTypes = {
  serif: PropTypes.bool,
  as: PropTypes.elementType,
  className: PropTypes.string,
  children: PropTypes.node,
  style: PropTypes.object,
};

export default SectionEyebrow;
